
const onMediaDetailsLoad = () => {
  const mediaDetails = document.getElementById('media-details');

  if (!mediaDetails) return;

  const tables = mediaDetails.querySelectorAll('table');

  tables.forEach((table) => {
    const wrapperDiv = document.createElement('div');
    wrapperDiv.classList.add('table-container');
    table.parentNode.insertBefore(wrapperDiv, table);
    wrapperDiv.appendChild(table);
  });

};

export default onMediaDetailsLoad;
